import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

import { DataViewModel } from '../../models/DataViewModel';
import { AnnouncementResponse } from '../../models/announcements/AnnouncementResponse';

@Injectable()
export class AnnouncementService {
  baseUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, ) {
    this.baseUrl = baseUrl;
  }

  public getAnnouncements(languageCode: string): Observable<DataViewModel<Array<AnnouncementResponse>>> {
    return this.http.get(this.baseUrl + 'api/Announcement/Announcements/' + languageCode)
      .map(response => <DataViewModel<Array<AnnouncementResponse>>>response)
      .catch(this.handleError);
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error || 'Server error');
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/announcements/announcement.service.ts